module.exports = __webpack_public_path__ + "static/media/4.beba0ccc.jpg";